export enum ApiRoutes {
    ViewContract        = "/api/v3/modules/sumaleasing/contrato/",
    GetContracts        = "/api/v3/modules/sumaleasing/contratos/",
    GetContractsExcel   = "/api/v3/modules/sumaleasing/contratos_excel/"
}